import React, { useEffect } from 'react';
import d from '../ConfirmDialog.module.css';
import s from './resources.module.css';

// The centred card the library's three dialogs share — a name, a
// destination, and the drawer's "Link an Online Resource" picker. The scrim,
// the card and its footer are ConfirmDialog's, so every centred dialog in the
// app is one shape; Escape closes, and a click on the scrim does not, for the
// reason ConfirmDialog gives.
export default function ResourceDialog({ open, title, onClose, children, footer }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className={d.scrim}>
      <div className={`${d.dialog} ${s.dialogTall}`} role="dialog" aria-modal="true" aria-label={title}>
        <div className={d.title}>{title}</div>
        <div className={s.dialogBody}>{children}</div>
        <div className={d.foot}>{footer}</div>
      </div>
    </div>
  );
}
